module.exports = __webpack_public_path__ + "img/booking_bulk.cb9e256d.svg";